<template>
  <div id="app">
    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->




<div class="wrapper">
		<div v-if="$route.name !='login'">
      <div class="main-header">
			<!-- Logo Header -->
            <logo_header></logo_header>
			<!-- End Logo Header -->

			<!-- Navbar Header -->
           <navbar></navbar>
			<!-- End Navbar -->


		</div>

		<!-- Sidebar -->
        <sidebar></sidebar>
		<!-- End Sidebar -->
    </div>


    <!-- Main Panel -->
      <router-view/>
    <!-- Main Panel -->
		
	</div>


    
  </div>
</template>


<script>
export default {
    data() {
        return {

        }
    },
    methods: {
        
    },
    mounted() {

    },

}
</script>
